export enum DownloadMimeType {
    CSV = 'text/csv',
    PDF = 'application/pdf',
    XML = 'application/xml',
    ZIP = 'application/zip'
}
